import React from 'react';
import { motion } from 'framer-motion';
export function TransformationSection() {
  const benefits = ['Despertarte liviana, sin esa sensación de vientre inflado', 'Terminar el día sin sentirte hinchada ni incómoda', 'Volver a ponerte ropa con confianza', 'Entender exactamente qué le está pasando a tu cuerpo', 'Comer sin miedo y sin sentirte culpable', 'Sentirte dueña de tu cuerpo otra vez'];
  return <section className="w-full bg-bg-softer py-16 px-4 md:px-8" data-id="element-226">
      <div className="max-w-3xl mx-auto" data-id="element-227">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-228">
          <p className="text-center text-accent text-sm uppercase tracking-wider mb-3" data-id="element-229">
            ✨ La Transformación
          </p>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif text-text-dark text-center mb-4" data-id="element-230">
            Imaginá cómo vas a sentirte en pocos días…
          </h2>

          <div className="text-center space-y-1 text-primary-mid mb-8" data-id="element-231">
            <p data-id="element-232">Volverte a mirar al espejo y sentirte bien</p>
            <p data-id="element-233">Ponerte ropa sin incomodidad</p>
            <p data-id="element-234">Comer sin miedo a hincharte</p>
          </div>

          <p className="text-center font-semibold text-text-dark mb-6" data-id="element-235">
            Con "Cero Inflamación" vas a poder:
          </p>

          <div className="grid sm:grid-cols-2 gap-3" data-id="element-236">
            {benefits.map((b, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex items-start gap-3 bg-white p-4 rounded-xl border border-secondary-light/20 shadow-sm" data-id="element-237">
                <span className="text-accent flex-shrink-0 mt-0.5" data-id="element-238">✔</span>
                <span className="text-primary-mid text-sm" data-id="element-239">{b}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}